import SevenTwentySevenRulesImagePlayer from "../../static/graphics/rules/Seven_Twenty_Seven_Player_Hand.svg";
import SevenTwentySevenRulesImagePlayerThreeCard from "../../static/graphics/rules/Player_Hand_3_Cards.svg";
import { GameRulesInterface } from "poker-cows-common";

export const SevenTwentySevenRules: GameRulesInterface = {
  objectives: [
    "Closest point total to 7 or 27 or both. Inside beats Outside, i.e. 7.5 beats 6.5 and 26.5 beats 27.5. Aces = 1 or 11. Face Cards = ½. All others = face value. ",
  ],
  card: {
    twoCard: ["2 Player Cards"],
    threeCard: ["3 Player Cards"],
  },
  image: {
    player: SevenTwentySevenRulesImagePlayer,
    playerTwoCard: SevenTwentySevenRulesImagePlayer,
    playerThreeCard: SevenTwentySevenRulesImagePlayerThreeCard,
  },
  actions: [
    "1. Each Player is dealt 1 or 2 cards down (depending on the game version) and 1 card up.",
    "2. Bet, starting with player left of dealer. Starting bet rotates each round.",
    '3. ALWAYS starting left of dealer, the players will choose either "Take Card" or "No Card."',
    '4. Bet, then repeat the round of "Take Card" or "No Card". Once a player has chosen "No Card" a total of 3 times, they are locked out from taking any additional cards.',
    "5. These “Card or No Card, Bet” rounds continue until there is a round where no player takes a card, or the player’s total is showing 26.5 or higher (2 Card version) or 26 or higher (3 Card version). Final Bet.",
    "6. Players declare “High” or “Low” or “Both”.",
    "7. Cards displayed; winners paid.",
  ],
};
